export default "__VITE_ASSET__DgvNsOzB__"